import { render, staticRenderFns } from "./BilanMonte.vue?vue&type=template&id=54604766&"
import script from "./BilanMonte.vue?vue&type=script&lang=js&"
export * from "./BilanMonte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports